
export enum RuleVisibilityFieldTypeValues {
    Defined = 'defined',
    Truthy = 'truthy',
    Falsey = 'falsey',
    Contains = 'contains',
    DoesNotContain = 'does_not_contain'
}

// Provide configurable field visibility
// Currently if any visible_config matches the field is visible
// Optionally configure visible_value to specify any defined value, or truthy/falsey value
// should be considered a match for visibility. This overrides any defined visible_prop_values
export interface IRuleVisibilityFieldTypeArgs {
    visible_configs: Array<{
        visible_prop_path: string,
        visible_prop_value: any,
        visible_value?: RuleVisibilityFieldTypeValues,
        visible_parent?: string
    }>
}

export interface IRuleRegularExpressionFieldTypeArgs {

    regex_pattern: string,
    regex_description?: string,
    regex_data_type?: "number" | 'string'

}

export interface IRuleArrayFieldTypeArgs {
    array_max_items?: number
}